import React from "react";
import { Card } from "antd";
import MediaFetcher from "../library/MediaFetcher";

const AdPreviewCard = ({ orgMedia }) => (
  <Card title="AD PREVIEW" className="ccard-image">
    <div style={{ backgroundColor: "#FAFAFA" }}>
      <MediaFetcher
        mediaKey={orgMedia && orgMedia.media && orgMedia.media.key}
        width="100%"
        height="280px"
        maxHeight="100%"
        objectFit="contain"
      />
    </div>
  </Card>
);

export default AdPreviewCard;
